import React from 'react';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import Typography  from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch, { SwitchProps } from '@mui/material/Switch';

const CustomSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 52,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(26px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#068A1E',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));
  const useStyles = makeStyles((theme) => ({
    customSwitch: { 
      "& .MuiTypography-root": {
        fontFamily: 'var(--auro-font-family-default)',
        color: '#00274A',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 450
    }}
  }));

 interface LockedSwitchProps {
    toggleSwitch: any; 
    isOn: boolean;
 } 
export default function LockedSwitch(props: LockedSwitchProps) {
    const {toggleSwitch, isOn} = props;
    const classes = useStyles();

    const handleLockedChange = () => {
        console.log("Locked switch changed to", !isOn)
        toggleSwitch(!isOn);
    }

    return (
        <React.Fragment>
            <div className="indent padding-top-12">
                <span className="basicLabel">Lock event</span>
            </div>
            <div className="indentSwitch">
                <Typography className={classes.customSwitch}>
                    <FormControlLabel
                         control={<CustomSwitch sx={{ m: 1 }}  />}
                        label="Locked"
                        labelPlacement="start"
                        checked={isOn}
                        onChange={handleLockedChange}
                    />
                </Typography>
            </div>
        </React.Fragment>
    );
}